// Browser compatibility polyfills
import './utils/browserPolyfills';
import { logger } from './utils/logger';
import * as Sentry from '@sentry/react';
import ErrorFallback from './components/ErrorFallback';

// Set document direction from stored preference before any rendering
const storedDirection = localStorage.getItem('documentDirection');
if (storedDirection === 'rtl') {
  document.documentElement.dir = 'rtl';
  logger.info('[App] Applied RTL from stored preference');
} else {
  document.documentElement.dir = 'ltr';
  logger.info('[App] Applied LTR (default or stored)');
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { LanguageProvider } from './contexts/LanguageContext'
import theme from './theme'
import App from './App'
import './index.css'
// Import i18n
import './i18n'

// Configure future flags for React Router
const routerFutureConfig = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <QueryClientProvider client={queryClient}>
          <LanguageProvider>
            <AuthProvider>
              <BrowserRouter future={routerFutureConfig}>
                <App />
              </BrowserRouter>
            </AuthProvider>
          </LanguageProvider>
        </QueryClientProvider>
      </ChakraProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
